module.exports = __webpack_public_path__ + "static/media/pdf.e98f4e1b.svg";